<div id="map"></div>
<input type="text" value="">
<div class="filtros-mapa position-absolute top-0 end-0">
  <ul class="d-flex flex-column gap-3 align-items-end width-1">
    <li>
      <div class="d-flex position-relative gap-2">
        <app-filtro-mapa [carregandoFiltros]="(carregandoTalhoes || carregandoEquipamentos)"
          (filtrosAplicados)="aplicarFiltros($event)"></app-filtro-mapa>
      </div>
    </li>
    <li>
      <button type="button" class="btn btn-light btn-mapa" (click)="alternarModalExportar()">
        <img src="assets/exportar-arquivos/download-icon.svg" alt="download" />
      </button>
    </li>
    <li>
      <div class="d-flex position-relative gap-2">
        <app-encontrar-equipamentos [hidden]="exibirModalEncontrarEquipamento" [loading]="carregandoEquipamentos"
          [operacaoComEquipamentos]="operacao"
          (geolocalizacaoSelecionada)="moveParaLocalizacao($event)"></app-encontrar-equipamentos>
        <button type="button" class="btn btn-light btn-mapa" (click)="abrirModalEquipamento()">
          <img src="assets/mapa/filtros/pesquisar-equipamentos.png" alt="Buscar Equipamento" />
        </button>
      </div>
    </li>
    <li>
      <div class="d-flex position-relative gap-2">
        <app-encontrar-talhoes [loading]="carregandoTalhoes" [hidden]="exibirModalEncontrarTalhoes"
          [fazendas]="fazendas" (talhaoSelecionado)="onTalhaoSelecionado($event)">
        </app-encontrar-talhoes>

        <button type="button" class="btn btn-light btn-mapa" (click)="abrirModalTalhoes()">
          <img src="assets/mapa/filtros/map-marker.svg" alt="Buscar Equipamento" />
        </button>
      </div>
    </li>
    <li>
      <div class="d-flex position-relative gap-2">
        <app-painel-camadas [hidden]="exibirPainelCamadas"></app-painel-camadas>
        <button type="button" class="btn btn-light btn-mapa" (click)="abrirPainelCamadas()">
          <img src="assets/mapa/filtros/camadas.svg" alt="Camadas do mapa" />
        </button>
      </div>
    </li>
  </ul>
</div>

<app-exportar-mapas-calor *ngIf="exportarMapaCalorModal"></app-exportar-mapas-calor>
<div class="container-principal" [class.informacoes-dialog-aberto]="dialogLegendas">
  <app-dialog-informacoes [legendaMapaAberto]="isLegendaMapaAberto" [clienteId]="filtrosAplicados?.clienteId"
    [dataInicio]="dataInicioISO" [dataFim]="dataFimISO" [atualizacaoAutonomiaInsumo]="atualizacaoAutonomiaInsumo"
    [alteracaoEstadoOperacao]="alteracaoEstadoOperacao"></app-dialog-informacoes>
  <app-dialog-legenda-mapa [operacaoId]="operacaoId" [tipo]="tipoMapaSelecionado.value" />
</div>
<div class="shape-loading-badge" *ngIf="carregandoShapes">
  Carregando fazendas
  <span class="shape-loading-spinner"></span>
</div>

<div class="position-absolute end-0 bottom-0 p-4 container-inferior">
  <div class="position-absolute end-0 bottom-0 p-4">

    <app-loading [hidden]="!carregandoMapasDisponiveis" [colunas]="1" [linhas]="1" [height]="1.6" cor="#e6e4e4">
    </app-loading>

    <div class="mapa-tipo-select" [hidden]="carregandoMapasDisponiveis">

      <object id="tipos-taxa" data="assets/mapa/select/tipos-mapa.svg" type="image/svg+xml">
        {{ 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.object_label' | transloco }}
      </object>

      <select class="form-select" [formControl]="tipoMapaSelecionado" (change)="mudarTaxaSelecionada()">

        <option selected hidden [value]="null">
          {{ 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.select_placeholder' | transloco }}
        </option>

        <option *ngFor="let mapa of mapasDisponiveis" [value]="mapa.tipo">
          {{ getMapTypeLabel(mapa) }}
        </option>

      </select>

    </div>

    <div class="painel-velocidade" *ngIf="tipoMapaSelecionado.value === 'velocidade'">
      <div class="cabecalho-painel-velocidade">
        <h3>{{ 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_titulo' | transloco }}</h3>

        <a [routerLink]="'/premoplan/velocidade-ideal'" class="btn-configuracoes"
          [title]="'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_configurar' | transloco"
          [attr.aria-label]="'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_configurar' | transloco">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path
              d="M19.14,12.94c0.04,-0.3,0.06,-0.61,0.06,-0.94c0,-0.32,-0.02,-0.64,-0.07,-0.94l2.03,-1.58c0.18,-0.14,0.23,-0.41,0.12,-0.61l-1.92,-3.32c-0.12,-0.22,-0.37,-0.29,-0.59,-0.22l-2.39,0.96c-0.5,-0.38,-1.03,-0.7,-1.62,-0.94L14.4,2.81c-0.04,-0.24,-0.24,-0.41,-0.48,-0.41h-3.84c-0.24,0,-0.43,0.17,-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29l-2.39,-0.96c-0.22,-0.08,-0.47,0,-0.59,0.22L2.74,8.87C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58c-0.18,0.14,-0.23,0.41,-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39,-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44,-0.17,0.47,-0.41l0.36,-2.54c0.59,-0.24,1.13,-0.56,1.62,-0.94l2.39,0.96c0.22,0.08,0.47,0,0.59,-0.22l1.92,-3.32c0.12,-0.22,0.07,-0.47,-0.12,-0.61L19.14,12.94z M12,15.6c-1.98,0,-3.6,-1.62,-3.6,-3.6s1.62,-3.6,3.6,-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
          </svg>
        </a>
      </div>

      <div class="indicador-velocidade">
        <div class="barra-tempos">
          <div class="tempo" *ngFor="let segmento of segmentosVelocidade()" [style.width]="segmento.valor + '%'"
            [style]="{'min-width': segmento.valor > 0 ? '35px' : '0', 'background': segmento.cor}">
            {{ segmento.valor }}%
          </div>
        </div>

        <div class="legenda">
          <div class="legenda-item" *ngFor="let segmento of segmentosVelocidade()">
            <span [style.background]="segmento.cor"></span>
            {{ segmento.label | transloco }}
          </div>
        </div>
      </div>
    </div>

    <div class="ofensores-produtividade" [hidden]="carregandoOfensoresProdutividade
              || tipoMapaSelecionado.value == 'rastros'
              || tipoMapaSelecionado.value == 'falhas'
              || tipoMapaSelecionado.value == 'velocidade'">

      <app-ofensores-produtividade [ofensoresProdutividade]="ofensoresProdutividade">
      </app-ofensores-produtividade>

    </div>

    <app-dialog-de-falhas *ngIf="tipoMapaSelecionado.value == 'falhas'" [operacaoId]="operacaoId">
    </app-dialog-de-falhas>

    <app-dialog-de-rastros *ngIf="tipoMapaSelecionado.value == 'rastros' && operacaoId" [operacaoId]="operacaoId">
    </app-dialog-de-rastros>

  </div>